<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <app-header></app-header>
    <app-drawer></app-drawer>
    <main class="mdl-layout__content">
      <router-view></router-view>
      <!-- <keep-alive>
      </keep-alive> -->
    </main>
    <app-action-bar></app-action-bar>
  </div>
</template>

<script>
import ActionBar from '../ActionBar/'
import Drawer from '../Drawer/'
import Footer from '../Footer/'
import Header from '../Header/'

export default {
  data () {
    return {

    }
  },
  components: {
    'app-action-bar': ActionBar,
    'app-drawer': Drawer,
    'app-footer': Footer,
    'app-header': Header
  },
  mounted () {
    componentHandler.upgradeElement(this.$el)
  }
}
</script>

<style lang="css" scoped>
  main.mdl-layout__content {
    background-color: rgb(230, 229, 229);
  }
</style>



// WEBPACK FOOTER //
// index.vue?b80dbbba